import React from "react";
import { useLocation } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "Components/Breadcrumbs";
import TripsChart from "./courses/TripsChart";
import TripsStackedChart from "./courses/TripsStackedChart";
import RecipesChart from "./recipes/RecipesChart";
import RecipesStackedChart from "./recipes/RecipesStackedChart";
import { STATISTICS } from "Constant";

const StatisticsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isRecettesRoute = location.pathname === "/statistics/recette";
  
  const breadCrumbsProps = [STATISTICS];
  
  return (
    <div className="grid">
      <div className="col-12 mb-2">
        <Card>
          <CardBody>
            <Breadcrumbs breadCrumbsProps={breadCrumbsProps} />
          </CardBody>
        </Card>
      </div>

      {isRecettesRoute ? (
        // Page des statistiques des recettes
        <>
          <div className="col-12">
            <Card>
              <CardBody>
                <RecipesChart />
              </CardBody>
            </Card>
          </div>
          <div className="col-12 mt-4">
            <Card>
              <CardBody>
                <RecipesStackedChart />
              </CardBody>
            </Card>
          </div>
        </>
      ) : (
        // Page des statistiques des courses
        <>
          <div className="col-12">
            <Card>
              <CardBody>
                <TripsChart />
              </CardBody>
            </Card>
          </div>
          <div className="col-12 mt-4">
            <Card>
              <CardBody>
                <TripsStackedChart />
              </CardBody>
            </Card>
          </div>
        </>
      )}
    </div>
  );
};

export default StatisticsPage;